export const FETCH_SHOOPY_STORES = "FETCH_STORES";
export const SHOOPY_STORE_PROGRESS = "STORE_PROGRESS";
export const SET_SHOOPY_STORE_ERROR = "SET_STORE_ERROR";
export const SET_SHOOPY_STORE_LOADER = "SET_STORE_LOADER";
export const CLEAR_SHOOPY_STORE = "CLEAR_STORE";
export const CLEAR_SHOOPY_COMPLETE_STORES = "CLEAR_COMPLETE_STORES";
export const SET_SHOOPY_STORES_PER_PAGE = "SET_STORES_PER_PAGE";
export const SET_SHOOPY_STORES_CURRENT_PAGE = "SET_STORES_CURRENT_PAGE";
export const SET_SHOOPY_STORES_MAX_PAGE_SO_FAR = "SET_STORES_MAX_PAGE_SO_FAR";
export const SET_SHOOPY_STORES_INPUT_KEYWORD = "SET_STORES_INPUT_KEYWORD";
export const SET_SHOOPY_STORES_SEARCH_KEYWORD = "SET_STORES_SEARCH_KEYWORD";
export const SET_SHOOPY_SUCCESS_TOAST = "SET_SUCCESS_TOAST";
export const UPDATE_SHOOPY_STORE = "UPDATE_SHOOPY_STORE";

